import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { refineContractRequiredMinimum } from "web_myplann/Portfolio/Forms/ContractShared/contractRequiredMinimum";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { optionalDateAsString } from "web_myplann/Shared/Validation/optionalDateAsString";
import { optionalPositiveFloat } from "web_myplann/Shared/Validation/optionalPositiveFloat";
import { refineDateOrder } from "web_myplann/Shared/Validation/refineDateOrder";
import { trimmedNullable } from "web_myplann/Shared/Validation/trimmedNullable";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import { z } from "zod";

export const getPensionFormSchema = (t: TranslateFunction) => {
	const maxMessage = t(Resources.Portfolio.AddShared.Validations.maxValue);
	const positiveNumberMessages = {
		positiveMessage: t(
			Resources.Portfolio.AddShared.Validations.positiveNumber,
		),
		maxMessage,
	};

	return z
		.object({
			name: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.LongName,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.LongName,
					}),
				),
			),
			contractNumber: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.Name,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.Name,
					}),
				),
			),
			producer: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.LongName,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.LongName,
					}),
				),
			),
			product: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.LongName,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.LongName,
					}),
				),
			),
			productCategoryId: z.number().nullable(),
			signedAt: optionalDateAsString(DateFormat.Iso),
			startAt: optionalDateAsString(DateFormat.Iso),
			endAt: optionalDateAsString(DateFormat.Iso),
			payment: optionalPositiveFloat(
				ValidationLimits.Amount.Max,
				positiveNumberMessages,
			),
			paymentFrequency: z
				.nativeEnum(ClientPortfolioPaymentFrequencyEnum)
				.nullable(),
		})
		.superRefine(
			refineDateOrder({
				startBeforeSigned: t(
					Resources.Portfolio.AddShared.Validations.startBeforeSigned,
				),
				endBeforeSigned: t(
					Resources.Portfolio.AddShared.Validations.endBeforeSigned,
				),
				endBeforeStart: t(
					Resources.Portfolio.AddShared.Validations.endBeforeStart,
				),
			}),
		)
		.superRefine(refineContractRequiredMinimum);
};

export type PensionFormInput = z.input<ReturnType<typeof getPensionFormSchema>>;
export type PensionFormOutput = z.output<
	ReturnType<typeof getPensionFormSchema>
>;
